module.exports = __webpack_public_path__ + "static/media/interaction-toggle-checkmark-on-big.46a0d0ac.svg";